import { render, staticRenderFns } from "./Fab.vue?vue&type=template&id=7c10adbc&scoped=true&"
import script from "./Fab.vue?vue&type=script&lang=ts&"
export * from "./Fab.vue?vue&type=script&lang=ts&"
import style0 from "./Fab.vue?vue&type=style&index=0&id=7c10adbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c10adbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFabTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VFabTransition})
